export default "\n<app-enquiry-contact></app-enquiry-contact>\n<app-header></app-header>\n\n<router-outlet></router-outlet>\n"